import {Component, Inject, Input, OnInit} from '@angular/core';
import {FormBuilder, Validators} from '@angular/forms';
import {IAppliedFiltersUpdater, IAppliedFiltersUpdaterToken} from '../../../applied-filters-updater';
import {AbstractFilterComponent} from '../../abstract-filter.component';
import {AdvancedFilterOperatorEnum, AdvanceFilterParamType} from '../../advance-filter';

@Component({
    selector: 'app-number-filter',
    templateUrl: './number-filter.component.html',
    styleUrl: './number-filter.component.scss'
})
export class NumberFilterComponent  extends AbstractFilterComponent<{availableOperators?: AdvancedFilterOperatorEnum[], minimalValue?:number, maximalValue?:number, step?:number }> implements OnInit {

    @Input() get availableOperators() {
        return this.options?.availableOperators || [AdvancedFilterOperatorEnum.gt, AdvancedFilterOperatorEnum.gte, AdvancedFilterOperatorEnum.lt, AdvancedFilterOperatorEnum.lte, AdvancedFilterOperatorEnum.eq, AdvancedFilterOperatorEnum.ne];
    }

    get minimalValue(): number {
        return this.options?.minimalValue || null// return this.item?.item?.field_validations?.min || null;
    }


    get maximalValue(): number {
        return this.options?.maximalValue || null///  return this.item?.item?.field_validations?.max || null;
    }

    get step(): number {
        return this.options?.step || null;
    }

    constructor(
        formBuilder: FormBuilder,
        @Inject(IAppliedFiltersUpdaterToken) filterUpdater: IAppliedFiltersUpdater<AdvanceFilterParamType>) {
        super(formBuilder, filterUpdater)
    }

    setUpForm() {
        this.filterForm = this._formBuilder.group({
            value: [null, [Validators.required]],
            value2: [null],
            operator: [this.operator, [Validators.required]],
        });
    }

    applyFilter() {
        if (this.filterForm.valid) {
            this.filterUpdater.update({
                ...this.item,
                isApplied: true,
                operator: this.filterForm.value.operator,
                value: this.getFilterValue()
            });
            this.popover.close();
        }
    }

    ngOnInit(): void {
        if (this.operator) {
            this.filterForm.controls['operator']?.setValue(this.operator);
        }

        this.filterForm.controls['value'].setValue(this.getValueByOperator());
        this.filterForm.controls['value2'].setValue(this.getValueByOperator(false));
    }

    protected readonly AdvancedFilterOperatorEnum = AdvancedFilterOperatorEnum;

    private getValueByOperator(firstValue: boolean = true) {
        if (this.filterForm?.value?.operator === AdvancedFilterOperatorEnum.between && this._value instanceof Array) {
            if (firstValue) {
                return this._value ? this._value[0] : null;
            } else {
                return this._value ? this._value[1] : null;
            }
        } else {
            return this.filterForm?.value;
        }
    }

    private getFilterValue() {
        if (this.filterForm?.value?.operator === AdvancedFilterOperatorEnum.between) {
            return [this.filterForm.value.value, this.filterForm.value.value2]
        } else {
            return this.filterForm.value.value;
        }
    }
}
